import React, { Component } from 'react';
import { connect } from 'react-redux';

import Footer from '../components/footer';
import buildEventDispatcher from '../../lib/event-dispatcher';

import {
  updateUserLanguage,
} from '../../actions/index';

class FooterContainer extends Component {
  constructor(props) {
    super(props);
    this.onLanguageChange = this.onLanguageChange.bind(this);
  }

  onLanguageChange(ev) {
    const { target: { value } } = ev;
    const { accessToken } = this.props;
    this.props.eventDispatcher.dispatchLanguageChangedEvent(value);
    this.props.updateUserLanguage(value, accessToken);
  }

  render() {
    const props = {
      onLanguageChange: this.onLanguageChange,
    };

    return (
      <Footer {...props} />
    );
  }
}

const mapStateToProps = (state) => {
  const { session: { authentication } } = state;

  return {
    eventDispatcher: buildEventDispatcher(state),
    accessToken: authentication.token,
  };
};

const mapDispatchToProps = {
  updateUserLanguage,
};

export default connect(mapStateToProps, mapDispatchToProps)(FooterContainer);



// WEBPACK FOOTER //
// ./src/desktop/containers/footer.container.js